import pages from "./pages";

export const ADDRESS_TYPE = {
  COMPANY: "COMPANY",
  CLIENT: "CLIENT",
};

export const CLIENT_TYPE = {
  USER: "CLIENT",
  BASE_STORAGE: "FACILITY",
  SECRET_ID: "Secret_ID",
};

export const CONTACT_TYPE = {
  PERSON: "PERSON",
  CLIENT: "CLIENT",
};

export const CONTENT_TYPE = {
  FUNCTION: "FUNCTION",
  PRODUCT_DELIVERY: "PRODUCT_DELIVERY",
  NEW_PRODUCT: "NEW_PRODUCT",
  PRODUCT_PICKUP: "PRODUCT_PICKUP",
  PICKUP: "PICKUP",
  FITTING: "FITTING",
  WORK: "WORK",
  BASE_STORAGE_MOVE: "BASE_STORAGE_MOVE",
};

//if added to cart or in draft mode
export const CONTENT_STATUS = {
  DRAFT: 0,
  CART: 10,
  ORDERED: 20,
  PROCESSED: 30,
  IN_PROGRESS: 80,
  COMPLETED: 90,
  ANNULLED: 99,
};

export const CONTENT_PATH = {
  FUNCTION: pages.FUNCTION_ORDER.PATH,
  PRODUCT_DELIVERY: pages.PRODUCT_ORDER.PATH,
  NEW_PRODUCT: pages.PRODUCTS_EXTERNAL_ASSORTMENT.PATH,
  PICKUP: pages.PICKUP_ORDER.PATH,
  FITTING: pages.FITTING.PATH,
  WORK: pages.WORK_ORDER.PATH,
};

export const LINKED_CATEGORIES = {
  IMAGE: "LinkedImages",
  DOCUMENT: "LinkedDocuments",
  VIDEO: "LinkedVideos",
};

export const FSP = "FSP";

export const COMMENT_TYPE = {
  INTERNAL: "INTERNAL",
  EXTERNAL: "EXTERNAL",
};

export const EDUCATION_OCCASION_ACTION = {
  REGISTER: "REGISTER",
  DEREGISTER: "DEREGISTER",
};

export const TASK_TYPES = {
  CA: "CA",
  CH: "CH",
  BSM: "BSM",
};

export const ACTION_TYPES = {
  MOVE: "MOVE",
  REPORT: "REPORT",
  RETURN: "RETURN",
};

export const FITTING_STATUS = {
  UNPLANNED: "UNPLANNED",
  ACTIVE: "ACTIVE",
  WAITING: "WAITING",
  CLOSED: "CLOSED",
};

export const STATUS = {
  ACTIVE: "ACTIVE",
  STARTED: "STARTED",
  REPORTED: "REPORTED",
  ALL: "ALL",
};

export const MOVE_OPTIONS = {
  DIRECT_MOVE: "DIRECT_MOVE",
  ORDER_MOVE: "ORDER_MOVE",
};

export const ID_SPLITTER = "¤";

export const ADVANCE_CONTACT_OPTION = {
  YES: "YES",
  NO: "NO",
};

export const DECEASED_DEREGISTRATION_CODE = "AV";

export const BLOCKED_ORDER_TYPES_FOR_DECEASED = [
  CONTENT_TYPE.FUNCTION,
  CONTENT_TYPE.PRODUCT_DELIVERY,
  CONTENT_TYPE.FITTING,
  CONTENT_TYPE.NEW_PRODUCT,
];
